/**
 * Surface C — `GET /api/user/buzz`, `POST|DELETE /api/user/buzz/link`.
 *
 * Money values are strings on the wire and stay strings all the way to the
 * renderer: they are never parsed into a float, never summed, never rounded.
 */

/** The link code's shape, byte for byte the server's own DTO pattern. */
export const BUZZ_CODE_PATTERN = /^DH-[A-Z2-9]{4}-[A-Z2-9]{4}$/

export type BuzzBalance = {
  available: string
  pending: string
}

/**
 * `unit` is deliberately typed `string`, not the literal `'points'`: the wire can
 * carry anything, and typing it as the literal would make the runtime check in
 * `deriveBuzzCardState` look unreachable and hand a wrong unit to the renderer.
 *
 * The same rule covers `balanceState` (a `string`, so an unknown value from a newer
 * nn stays a reachable case rather than a type error) and the two per-figure fields
 * `pointsEarned` and `paidCalls` (`unknown` and optional: an older nn omits them, and
 * each is validated on its own before it is shown). That is also why this is one
 * loose object rather than a union discriminated on `balanceState`: a `string`
 * discriminant discriminates nothing.
 */
export type BuzzStatus = {
  linked: boolean
  balanceState: string
  linkedAt?: string
  unit?: string
  balance?: BuzzBalance | null
  pointsEarned?: unknown
  paidCalls?: unknown
}

export type LinkBuzzRequest = {
  code: string
}

export type LinkBuzzResponse = {
  linked: true
  linkedAt: string
}
